import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DropdownComponent from "@/components/tools/DropdownComponent.vue";


// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'fortuneConfigDropDown',
  props: {
  options: Array,
  modelValue: Object,
  isDisable: { type: Boolean, default: false },
  index: Number
},
  emits: ['onFortuneOptionSelected'],
  setup(__props, { emit }) {

const props = __props





const onOptionSelected = (e: any) => {
  emit('onFortuneOptionSelected', { index: props.index, value: e });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DropdownComponent, {
    class: "w-full",
    options: __props.options,
    modelValue: __props.modelValue,
    onOnOptionSelected: onOptionSelected
  }, null, 8, ["options", "modelValue"]))
}
}

})